module.exports = __webpack_public_path__ + "static/img/cancel.1fac56b8.svg";